import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext, useContext, useState, useEffect } from 'react';
import keycloakService from '../services/KeycloakService';
const AuthContext = createContext(undefined);
export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [tenant, setTenant] = useState();
    // Función para convertir UserInfo de Keycloak a User de la aplicación
    const mapKeycloakUserToAppUser = (keycloakUser) => {
        return {
            id: keycloakUser.id,
            email: keycloakUser.email,
            name: keycloakUser.name,
            role: keycloakUser.roles[0] || 'user',
            username: keycloakUser.username,
            firstName: keycloakUser.firstName,
            lastName: keycloakUser.lastName,
            roles: keycloakUser.roles,
            permissions: keycloakUser.permissions,
            realm: keycloakUser.realm,
        };
    };
    useEffect(() => {
        const initializeAuth = async () => {
            try {
                const authenticated = await keycloakService.initialize();
                if (authenticated) {
                    const userInfo = await keycloakService.getUserInfo();
                    if (userInfo) {
                        setUser(mapKeycloakUserToAppUser(userInfo));
                        setIsAuthenticated(true);
                        console.log("userInfo", userInfo);
                        setTenant(keycloakService.getTenant());
                    }
                    else {
                        setUser(null);
                        setIsAuthenticated(false);
                    }
                }
                else {
                    setUser(null);
                    setIsAuthenticated(false);
                }
            }
            catch (error) {
                console.error(error);
                setUser(null);
                setIsAuthenticated(false);
            }
            finally {
                setIsLoading(false);
            }
        };
        initializeAuth();
    }, []);
    const login = async () => {
        try {
            setIsLoading(true);
            console.log('🔐 Iniciando proceso de login...');
            // Login con Keycloak (solo si está habilitado)
            await keycloakService.login();
        }
        catch (error) {
            console.error('❌ Error en login:', error);
            setIsLoading(false);
            throw error;
        }
    };
    const logout = async () => {
        try {
            setIsLoading(true);
            console.log('🔐 Cerrando sesión...');
            setUser(null);
            setIsAuthenticated(false);
            // Logout con Keycloak (solo si está habilitado)
            await keycloakService.logout();
        }
        catch (error) {
            console.error('❌ Error en logout:', error);
            setIsLoading(false);
            throw error;
        }
    };
    const hasPermission = (permission) => {
        // Verificación con Keycloak (solo si está habilitado)
        return keycloakService.hasPermission(permission);
    };
    const refreshToken = async () => {
        // Refresh con Keycloak (solo si está habilitado)
        try {
            return await keycloakService.refreshToken();
        }
        catch (error) {
            console.error('❌ Error refrescando token:', error);
            return false;
        }
    };
    const getToken = () => {
        // Token de Keycloak (solo si está habilitado)
        return keycloakService.getToken();
    };
    const getTenant = () => {
        return keycloakService.getTenant();
    };
    const value = {
        user,
        isAuthenticated,
        isLoading,
        login,
        logout,
        hasPermission,
        refreshToken,
        getToken,
        tenant
    };
    return (_jsx(AuthContext.Provider, { value: value, children: children }));
};
export const useAuth = () => {
    const context = useContext(AuthContext);
    if (context === undefined) {
        throw new Error('useAuth must be used within an AuthProvider');
    }
    return context;
};
